/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaoBaoSkuVo
 */
export interface TaoBaoSkuVo {
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    proNm?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    proNmEn?: string;
    /**
     * 
     * @type {number}
     * @memberof TaoBaoSkuVo
     */
    stock?: number;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    imgUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    proCost?: string;
    /**
     * 
     * @type {number}
     * @memberof TaoBaoSkuVo
     */
    proQty?: number;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    proUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    shopOrderNo?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    shopSite?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoSkuVo
     */
    skuId?: string;
}

/**
 * Check if a given object implements the TaoBaoSkuVo interface.
 */
export function instanceOfTaoBaoSkuVo(value: object): value is TaoBaoSkuVo {
    return true;
}

export function TaoBaoSkuVoFromJSON(json: any): TaoBaoSkuVo {
    return TaoBaoSkuVoFromJSONTyped(json, false);
}

export function TaoBaoSkuVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaoBaoSkuVo {
    if (json == null) {
        return json;
    }
    return {
        
        'proNm': json['proNm'] == null ? undefined : json['proNm'],
        'proNmEn': json['proNmEn'] == null ? undefined : json['proNmEn'],
        'stock': json['stock'] == null ? undefined : json['stock'],
        'color': json['color'] == null ? undefined : json['color'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'proCost': json['proCost'] == null ? undefined : json['proCost'],
        'proQty': json['proQty'] == null ? undefined : json['proQty'],
        'proUrl': json['proUrl'] == null ? undefined : json['proUrl'],
        'shopOrderNo': json['shopOrderNo'] == null ? undefined : json['shopOrderNo'],
        'shopSite': json['shopSite'] == null ? undefined : json['shopSite'],
        'size': json['size'] == null ? undefined : json['size'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
    };
}

export function TaoBaoSkuVoToJSON(json: any): TaoBaoSkuVo {
    return TaoBaoSkuVoToJSONTyped(json, false);
}

export function TaoBaoSkuVoToJSONTyped(value?: TaoBaoSkuVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proNm': value['proNm'],
        'proNmEn': value['proNmEn'],
        'stock': value['stock'],
        'color': value['color'],
        'imgUrl': value['imgUrl'],
        'proCost': value['proCost'],
        'proQty': value['proQty'],
        'proUrl': value['proUrl'],
        'shopOrderNo': value['shopOrderNo'],
        'shopSite': value['shopSite'],
        'size': value['size'],
        'skuId': value['skuId'],
    };
}

